module.exports = __webpack_public_path__ + "static/media/circle-in-square.82781d92.png";